import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNotepadplusplusComponent } from './simple-icons-notepadplusplus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNotepadplusplusComponent ],
    exports:      [ SimpleIconsNotepadplusplusComponent ],
    bootstrap:    []
})
export class SimpleIconsNotepadplusplusModule {}
